import { render, staticRenderFns } from "./MarketingSalesDetail.vue?vue&type=template&id=677bff7c&"
import script from "./MarketingSalesDetail.vue?vue&type=script&lang=js&"
export * from "./MarketingSalesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports